import React from 'react';
import { Form, Formik } from 'formik';

import { CSSObjectWithLabel } from 'react-select';

import ModalFormDropdown from '@/components/business/ModalForm/ModalFormDropdown/ModalFormDropdown';
import Button, { ButtonStyleType } from '@/components/common/Button/Button';
import AgModalWindow from '@/components/common/ModalWindow/AgModalWindow';
import { getDirectDebits } from '@/utils/data-helpers/directDebits';
import { Fields, validationSchema } from './validation';
import ActionButtonsWrapper from '@/components/common/ModalWindow/ActionButtonsWrapper/ActionButtonsWrapper';

interface IDirectDebitModalProps {
  onClose: () => void;
  onSubmit: (directDebitType: NonNullable<Contract['directDebit']>['type']) => void;
  contract: Contract | null;
}

export default function DirectDebitModal({ onClose, onSubmit, contract }: IDirectDebitModalProps) {
  const directDebits = getDirectDebits();

  return (
    <AgModalWindow
      isOpen={true}
      onClose={onClose}
      title="Direct Debit"
      contentStyle={{ width: 340 }}
    >
      <Formik<Fields>
        initialValues={{ directDebitType: contract?.directDebit?.type }}
        validationSchema={validationSchema}
        onSubmit={(values) => onSubmit(values.directDebitType!)}
        validateOnMount={true}
      >
        {({ values, errors, touched, dirty, isValid, setFieldValue, setFieldTouched }) => (
          <Form>
            <ModalFormDropdown<NonNullable<Contract['directDebit']>>
              id="directDebitType"
              labelTitle="Direct Debit Options"
              requiredIcon={true}
              isSearchable={false}
              optionsData={directDebits}
              placeholder="Select option"
              getOptionLabel={(option) => option.formattedType}
              getOptionValue={(option) => option.type}
              selectedOption={directDebits.find((el) => el.type === values.directDebitType)}
              menuPortalTarget={document.querySelector('body')}
              customStyles={{
                menuList: (provided) => ({ ...provided, maxHeight: 250 } as CSSObjectWithLabel)
              }}
              handleChange={(selectedOption) => {
                setFieldTouched('directDebitType');
                setFieldValue('directDebitType', selectedOption?.type);
              }}
              validationMessage={
                (errors?.directDebitType && touched.directDebitType) ? errors.directDebitType : undefined
              }
            />

            <ActionButtonsWrapper
              leftButton={(
                <Button
                  buttonStyleType={ButtonStyleType.SECONDARY}
                  onClick={onClose}
                >
                  Cancel
                </Button>
              )}
              rightButton={(
                <Button
                  disabled={!isValid || !dirty}
                  buttonStyleType={ButtonStyleType.PRIMARY}
                  type="submit"
                >
                  Save
                </Button>
              )}
            />
          </Form>
        )}
      </Formik>
    </AgModalWindow>
  );
}
